import { Module } from 'tabulator-tables';
import TabulatorCellFormatter from "@root/enums/TabulatorCellFormatter";
import actions from "@root/tabulator/CellFormatters/actions";
import array from "@root/tabulator/CellFormatters/array";
import beatingHeart from "@root/tabulator/CellFormatters/beatingHeart";
import cleanedLink from "@root/tabulator/CellFormatters/cleanedLink";
import concatenate from "@root/tabulator/CellFormatters/concatenate";
import condition from "@root/tabulator/CellFormatters/condition";
import dateDue from "@root/tabulator/CellFormatters/dateDue";
import email from "@root/tabulator/CellFormatters/email";
import financeOpportunity from "@root/tabulator/CellFormatters/financeOpportunity";
import financeOpportunityStatus from "@root/tabulator/CellFormatters/financeOpportunityStatus";
import fontAwesomeIcon from "@root/tabulator/CellFormatters/fontAwesomeIcon";
import image from "@root/tabulator/CellFormatters/image";
import imageMultiple from "@root/tabulator/CellFormatters/imageMultiple";
import number from "@root/tabulator/CellFormatters/number";
import poStatus from "@root/tabulator/CellFormatters/poStatus";
import salesOrderStatus from "@root/tabulator/CellFormatters/salesOrderStatus";
import shortNumber from "@root/tabulator/CellFormatters/shortNumber";
import telephone from "@root/tabulator/CellFormatters/telephone";
import trailerConfigStatus from '@root/tabulator/CellFormatters/trailerConfigStatus';
import xero from "@root/tabulator/CellFormatters/xero";

import checkStatus from "@root/tabulator/CellFormatters/checkStatus";
import textBlock from "@root/tabulator/CellFormatters/textBlock";

import moneyFormatter from "@root/tabulator/CellFormatters/money";
import TabulatorMutator from "@root/enums/TabulatorMutator";
import money from "@root/tabulator/Mutators/money";
import trim from "@root/tabulator/Mutators/trim";
import webrotate from "@root/tabulator/CellFormatters/webrotate";

export default class NewtonTrailersModule extends Module {

  static moduleName = "newtontrailers";

  static moduleExtensions = {
    format: {
      formatters: {
        [TabulatorCellFormatter.ACTIONS.lowerEnumKey()]: actions,
        [TabulatorCellFormatter.ARRAY.lowerEnumKey()]: array,
        [TabulatorCellFormatter.BEATING_HEART.lowerEnumKey()]: beatingHeart,
        [TabulatorCellFormatter.CHECK_STATUS.lowerEnumKey()]: checkStatus,
        [TabulatorCellFormatter.CONCATENATE.lowerEnumKey()]: concatenate,
        [TabulatorCellFormatter.CONDITION.lowerEnumKey()]: condition,
        [TabulatorCellFormatter.DATE_DUE.lowerEnumKey()]: dateDue,
        [TabulatorCellFormatter.EMAIL.lowerEnumKey()]: email,
        [TabulatorCellFormatter.FINANCE_ESTIMATE.lowerEnumKey()]: financeOpportunity,
        [TabulatorCellFormatter.FINANCE_ESTIMATE_STATUS.lowerEnumKey()]: financeOpportunityStatus,
        [TabulatorCellFormatter.FONT_AWESOME_ICON.lowerEnumKey()]: fontAwesomeIcon,
        [TabulatorCellFormatter.IMAGE.lowerEnumKey()]: image,
        [TabulatorCellFormatter.IMAGE_MULTIPLE.lowerEnumKey()]: imageMultiple,
        [TabulatorCellFormatter.LINK.lowerEnumKey()]: cleanedLink,
        [TabulatorCellFormatter.MONEY.lowerEnumKey()]: moneyFormatter,
        [TabulatorCellFormatter.NUMBER.lowerEnumKey()]: number,
        [TabulatorCellFormatter.PO_STATUS.lowerEnumKey()]: poStatus,
        [TabulatorCellFormatter.SALES_ORDER_STATUS.lowerEnumKey()]: salesOrderStatus,
        [TabulatorCellFormatter.SHORT_NUMBER.lowerEnumKey()]: shortNumber,
        [TabulatorCellFormatter.TELEPHONE.lowerEnumKey()]: telephone,
        [TabulatorCellFormatter.TEXT_BLOCK.lowerEnumKey()]: textBlock,
        [TabulatorCellFormatter.TRAILER_CONFIG_STATUS.lowerEnumKey()]: trailerConfigStatus,
        [TabulatorCellFormatter.WEBROTATE.lowerEnumKey()]: webrotate,
        [TabulatorCellFormatter.XERO.lowerEnumKey()]: xero,
      }
    },
    mutator: {
      mutators: {
        [TabulatorMutator.TRIM.lowerEnumKey()]: trim,
        [TabulatorMutator.MONEY.lowerEnumKey()]: money,
      }
    },
    filter: {
      filters: {
        between: () => {
        },
        creator: () => {
        },
        beating_heart: () => {
        },
      }
    }
  }

  constructor(table) {
    super(table);

    this.registerColumnOption('ajax', false);
    this.registerColumnOption('columnGroupTitle', '');
    this.registerColumnOption('rowFormatter', null);
  }

  initialize() {
    //called by the table when it is ready for module integrations
  }
}